import { hasYesOrNo, checkValue } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { daterangeOverlap } from 'helpers/date';
import { parseSafeDateTimeRange, SafeDateTimeRange } from 'helpers/dates/dateRange';
import isEqual from 'lodash/isEqual';
import { FormDetails } from 'util/singletons';
import { isPVQForm } from 'helpers/form';
import citizenshipValidator from './validators/item';
import { CitizenshipMultipleModel } from './types';

function getOverlaps(citizenshipList: any) {
  const duplicateData = [];

  for (let index = 0; index < citizenshipList.items?.length; index++) {
    for (let subIndex = 0; subIndex < citizenshipList.items?.length; subIndex++) {
      if (index !== subIndex) {
        const firstDaterange: SafeDateTimeRange = parseSafeDateTimeRange(citizenshipList.items[index].Item?.Dates);
        const secondDaterange: SafeDateTimeRange = parseSafeDateTimeRange(citizenshipList.items[subIndex].Item?.Dates);

        if (firstDaterange.valid && secondDaterange.valid && daterangeOverlap(firstDaterange, secondDaterange)
        && isEqual(citizenshipList.items[index].Item.Country?.value, citizenshipList.items[subIndex].Item.Country?.value)) {
          duplicateData.push({ Country: citizenshipList.items[index].Item.Country, Dates: citizenshipList.items[index].Item.Dates });
          break;
        }
      }
    }
  }

  return duplicateData;
}

const citizenshipMultipleValidator: ValidateJSModel<CitizenshipMultipleModel> = {
  HasMultiple: { presence: true, hasValue: { validator: hasYesOrNo } },
  Comments: {},
  SummaryComments: {},

  List: (value, attributes, attributeName, options) => {
    let duplicateData: any[] = [];
    let lengthValidator: any = {};
    const formDetails = FormDetails.getInstance().getData();
    if (value) {
      duplicateData = getOverlaps(value);
    }

    // Length validator is only needed for SF8X, needs to be double checked for PVQ
    if (!isPVQForm(formDetails.formType)) {
      lengthValidator = { minimum: 2, tooShort: 'error.list.length.citizenshipMin' };
    }

    return checkValue(attributes?.HasMultiple, 'Yes')
      ? {
        presence: true,
        accordion: {
          validator: citizenshipValidator,
          length: lengthValidator,
          // fixes typing error
          ...(options as object),
          duplicateData,
        },
      }
      : {};
  }
};

export default citizenshipMultipleValidator;
